import React from 'react';
import { Container } from 'reactstrap';
import { useSelector } from 'react-redux';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { getAuthToken } from '../../auth/tokenvalidation';
import MitraDashboard from './MitraDashboard';
import StaffDashboard from './StaffDashboard';
import './dashboard.css';

// Registered Suppliers see their own invitations and offers; every other role sees the
// procurement overview. The API decides what each role may read (403 -> "no dashboard").
const SUPPLIER_ROLE = 'Registered Supplier';

const Dashboard = () => {
  document.title = 'Dashboard';

  const { user } = useSelector(state => state.Login);
  const userRoles = user?.role?.split(',').map(r => r.trim()) || [];
  const token = getAuthToken();
  const isSupplier = userRoles.includes(SUPPLIER_ROLE);

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title='Dashboard' pageTitle='Overview' />
        {isSupplier ? (
          <MitraDashboard token={token} user={user} />
        ) : (
          <StaffDashboard token={token} user={user} />
        )}
      </Container>
    </div>
  );
};

export default Dashboard;
